var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _g, _circle10, _circle11, _circle12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceCirclesBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1199,
    height: 900,
    viewBox: "0 0 1199 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 599.455,
    cy: 450,
    r: 409.986,
    stroke: "url(#paint0_linear_2776_5865)",
    strokeWidth: 0.456555,
    strokeLinecap: "round",
    strokeDasharray: "1.83 2.74"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 599.454,
    cy: 450.001,
    r: 512.255,
    stroke: "url(#paint1_linear_2776_5865)",
    strokeWidth: 0.456555,
    strokeLinecap: "round",
    strokeDasharray: "1.83 2.74"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 599.457,
    cy: 450,
    r: 599,
    stroke: "url(#paint2_linear_2776_5865)",
    strokeWidth: 0.456555,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.311,
    cy: 103.018,
    r: 5.70694,
    fill: "white",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 380.311,
    cy: 103.018,
    r: 5.70694,
    fill: "url(#paint3_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.675,
    cy: 458.218,
    r: 8.44627,
    fill: "white",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 87.675,
    cy: 458.218,
    r: 8.44627,
    fill: "url(#paint4_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1111.71,
    cy: 442.695,
    r: 8.44627,
    fill: "url(#paint5_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1004.88,
    cy: 511.179,
    r: 8.44627,
    fill: "white",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 1004.88,
    cy: 511.179,
    r: 8.44627,
    fill: "url(#paint6_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.5031,
    cy: 163.282,
    r: 8.44627,
    fill: "#C9F3F7",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 839.604,
    cy: 117.627,
    r: 5.70694,
    fill: "white",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 839.604,
    cy: 117.627,
    r: 5.70694,
    fill: "url(#paint7_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 1185.67,
    cy: 325.818,
    r: 8.44627,
    fill: "white",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1185.67,
    cy: 325.818,
    r: 8.44627,
    fill: "url(#paint8_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.67502,
    cy: 546.788,
    r: 8.44627,
    fill: "url(#paint9_radial_2776_5865)",
    stroke: "#F9FAFF",
    strokeWidth: 0.456555
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2776_5865",
    x1: 599.455,
    y1: 40.0137,
    x2: 599.455,
    y2: 859.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239915,
    stopColor: "#6C71FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769524,
    stopColor: "#6C71FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2776_5865",
    x1: 599.454,
    y1: -62.2539,
    x2: 599.454,
    y2: 962.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0295103,
    stopColor: "#BDBFF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33482,
    stopColor: "#6C71FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711269,
    stopColor: "#6C71FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBFF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2776_5865",
    x1: 599.457,
    y1: -149,
    x2: 599.457,
    y2: 1049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140739,
    stopColor: "#A9ACFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328322,
    stopColor: "#45478D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690813,
    stopColor: "#45478D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858117,
    stopColor: "#A9ACFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(380.311 103.018) rotate(90) scale(8.52236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B7B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.675 458.218) rotate(90) scale(12.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1111.71 442.695) rotate(90) scale(12.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F7CFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1004.88 511.179) rotate(90) scale(12.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04F4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B7B0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(839.604 117.627) rotate(90) scale(8.52236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7782FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4169FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1185.67 325.818) rotate(90) scale(12.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7782FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4169FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2776_5865",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.67502 546.788) rotate(90) scale(12.7835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7782FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4169FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceCirclesBackground);
export default __webpack_public_path__ + "static/media/space-circles-background.ef18ac430a7d35c4b8eb5d2631239be6.svg";
export { ForwardRef as ReactComponent };